<template>
  <div style="height:100%">
    <Button
      v-if="infoCtrl && editState" class="add-btn"
      type="primary" style="  margin-left:550px ; float: left; margin-top: -64px;"
      @click="getEvidenceExchangeInfo('edit')"
    >修改</Button>
    <Form
      v-if="!infoCtrl" ref="formValidate"
      class="case-form" :model="formValidate"
      :rules="ruleValidate" :label-width="100"
    >
      <FormItem label="证据交换时间" prop="exchangeTime">
        <DatePicker
          :value="formValidate.exchangeTime" style="width:100%"
          type="date" placeholder="请填写证据交换时间"
          @on-change="getExchangeTime"
        />
      </FormItem>
      <FormItem
        label="地点" prop="exchangeAddress"
        :rules="[{ max:128, message:'长度不能超过128个字符', trigger:'blur' }]"
      >
        <Input v-model="formValidate.exchangeAddress" placeholder="请输入证据交换地点" />
      </FormItem>
      <FormItem
        label="参与人员" prop="participants"
        :rules="[{ max:56, message:'长度不能超过56个字符', trigger:'blur' }]"
      >
        <Input v-model="formValidate.participants" placeholder="请输入参与人员" />
      </FormItem>
      <FormItem label="对方证据" prop="attachmentList">
        <file-upload
          :default-list="defaultList || []"
          :upload-config="uploadConfig"
          @getFileList="getAttachmentList"
        />
      </FormItem>
      <Row class="detail-btn-box">
        <Button
          type="primary" style="margin-right:10px;"
          :disabled="isSubmit" @click="submit"
        >保存</Button>
        <Button @click="getEvidenceExchangeInfo()">取消</Button>
      </Row>
    </Form>
    <Row v-if="infoCtrl" class="detail-content">
      <Row><Col span="5" class="left-label">证据交换时间：</Col><Col span="16" class="right-content">{{ evidenceInfo.exchangeTimeStr }}</Col></Row>
      <Row><Col span="5" class="left-label">地点：</Col><Col span="16" class="right-content">{{ evidenceInfo.exchangeAddress }}</Col></Row>
      <Row><Col span="5" class="left-label">参与人员：</Col><Col span="16" class="right-content">{{ evidenceInfo.participants }}</Col></Row>
      <Row>
        <Col span="5" class="left-label">对方证据：</Col>
        <Col span="16" class="right-content">
          <file-upload
            :default-list="evidenceInfo.attachmentList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['processId', 'caseId', 'editState'],
  data () {
    return {
      editId: '',
      formValidate: {
        exchangeTime: '',
        exchangeAddress: '',
        participants: '',
        attachmentList: []
      },
      ruleValidate: {
        exchangeTime: [{ required: true, message: '公告日期不能为空', trigger: 'blur' }]
      },
      uploadConfig: {
        fileName: ''
      },
      defaultList: [],
      isSubmit: false,
      infoCtrl: false,
      evidenceInfo: ''
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getEvidenceExchangeInfo()
  },
  mounted() {},
  updated() {},
  methods: {
    getInputValue(data, name) {
      this.formValidate[name] = data
    },
    getExchangeTime(data) {
      this.formValidate.exchangeTime = data
    },
    // 获取图片列表
    getAttachmentList (arr) {
      this.formValidate.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.attachmentList.push(obj)
      })
    },
    submit() {
      this.$refs['formValidate'].validate((vaild) => {
        if (vaild) {
          this.isSubmit = true
          const url = '/business/case/evidence-exchange'
          const ajaxData = {}
          Object.assign(ajaxData, this.formValidate)
          ajaxData.processId = this.processId
          ajaxData.caseId = this.caseId
          if (this.editId) {
            ajaxData.id = this.editId
            this.$patch(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
              this.getEvidenceExchangeInfo()
            })
          } else {
            this.$post(url, ajaxData).then(res => {
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
              this.isSubmit = false
              this.getEvidenceExchangeInfo()
            })
          }
        }
      })
    },
    // 获取详情
    getEvidenceExchangeInfo(type) {
      const url = '/business/case/evidence-exchange/' + this.processId
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.evidenceInfo = res.data
          this.infoCtrl = type != 'edit'
          if (type == 'edit') {
            this.getDetail(this.evidenceInfo)
          }
        } else if (this.editState == false) {
          this.infoCtrl = true
        } else {
          this.infoCtrl = false
        }
      })
    },
    getDetail(value) {
      const data = JSON.parse(JSON.stringify(value))
      this.editId = data.id
      for (const key in this.formValidate) {
        this.formValidate[key] = data[key]
      }
      this.formValidate.exchangeTime = data.exchangeTimeStr
      this.defaultList = data.attachmentList.length > 0 ? data.attachmentList.map(item => {
        return {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
      }) : []
      this.formValidate.attachmentList = this.defaultList
    }
  }
}
</script>
<style scoped lang="scss">
@import '../caseCommon.scss';
.add-btn{
    margin-top:-64px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/pretrial/evidenceExchange.vue